
import { Flex, Button, Typography, Grid } from "antd";
import { CalendarListIcon, LocationPin2Icon } from "../../assets/CustomIcon";

import { getJwtPayload, getUserType, formatDateTime } from "../../utils/appUtils";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function EventHeader(props) {
    const { event, customizedButtons, className = "" } = props;
    const screens = useBreakpoint();

    const token = localStorage.getItem('authToken');
    const userPayload = getJwtPayload(token);
    const activeRole = getUserType();

    // Helper to safely extract name from object or return string as-is
    const getStringValue = (value, fallback = "") => {
        if (!value) return fallback;
        if (typeof value === 'string') return value;
        if (typeof value === 'object') return value.name || value.venue_name || fallback;
        return fallback;
    };

    const eventName = event?.event_name || "Event Name";
    const venueName = getStringValue(event?.venue) || getStringValue(event?.event_venue) || "Venue TBD";
    const startDateTime = formatDateTime(event?.event_start_date_time) || "Start Date Time";
    const actionButtons = Array.isArray(customizedButtons) ? customizedButtons : [];
    const hostName = activeRole === "organizer" && userPayload
        ? `${userPayload?.first_name} ${userPayload?.last_name}`
        : "System Admin";

    return (
        <div className={`event-header ${className}`.trim()}>
            <Flex gap={16} justify="space-between" align="flex-start" vertical={!screens.md} className="eventHeaderTop">
                <div className="eventHeadingWrap">
                    <Title level={2} strong className="event-title">
                        {eventName}
                    </Title>
                    <div className={!screens.md ? null : "event-title-underline"} />
                </div>

                <Flex gap={12} wrap className="eventHeaderActions">
                    {actionButtons.map((buttonObj) => (
                        <Button
                            key={buttonObj.text}
                            type={buttonObj.type}
                            className={buttonObj.className}
                            style={{ width: screens.md ? 170 : "100%" }}
                            onClick={buttonObj.onClick}
                            disabled={buttonObj.disabled}
                        >
                            {buttonObj.text}
                        </Button>
                    ))}
                </Flex>
            </Flex>

            <Flex gap={12} wrap className="eventMetaChips">
                <Text className="event-meta-chip">
                    <span className="event-icon event-icon-circle gradient-icon"></span>
                    <strong>{hostName}</strong>
                </Text>

                <Text className="event-meta-chip">
                    <span className="event-icon">
                        <LocationPin2Icon />
                    </span>
                    {venueName}
                </Text>

                <Text className="event-meta-chip">
                    <span className="event-icon">
                        <CalendarListIcon />
                    </span>
                    {startDateTime}
                </Text>
            </Flex>
        </div>
    );
}